import { NavLink, useHistory } from "react-router-dom";
import { useUserInfor } from "../../../Context/User/";
import { ACESSOS } from "../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../Validations/UsuarioTela";
import SubNavProdutos from "../CobrancaTab/subnavs/Produtos";
//import SubNavProdutos from "../CobrancaTab/subnavs/Produtos";
import SubNavDropDown from "../SubNavDropDown/SubNavDropDown";
import { SubNavGestaoVenCadastro } from "./subnavs/ResultadoContato/GestaoVenCadastro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faMapMarked, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import SubNavRelatoriosBI from "./subnavs/RelatoriosBI/SubNavRelatoriosBI";
import { SubNavGestaoRespostasVendas } from "./subnavs/SubNavGestaoRespostasVendas/SubNavGestaoRespostasVendas";
export default function VendasTab() {
    const { UserInfor } = useUserInfor();

    const history = useHistory();

    return (
        <>
            <div className="tab-pane py-5 p-lg-0 active" id="RepasseTab">
                <div
                    id="kt_header_menu2"
                    className="header-menu header-menu-mobile header-menu-layout-default header-menu-root-arrow"
                >
                    <ul className="menu-nav">
                        {mostrarNavDeTela(
                            ACESSOS.VENDAS.TELAS.PAINEL_RESUMO.ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <li className="menu-item">
                                <NavLink
                                    to={
                                        ACESSOS.VENDAS.TELAS.PAINEL_RESUMO
                                            .DS_PATH
                                    }
                                    exact
                                    activeClassName="active"
                                    className="menu-link"
                                >
                                    <span className="menu-text">Dashboard</span>
                                </NavLink>
                            </li>
                        )}

                        {UserInfor.TELAS
                            ? UserInfor.TELAS.map((tela) => {
                                  if (
                                      tela.ID_TELA ===
                                      ACESSOS.VENDAS.TELAS.DASHBOARD.ID_TELA
                                  ) {
                                      return (
                                          <li
                                              key={tela.ID_TELA}
                                              className="menu-item"
                                          >
                                              <NavLink
                                                  to={
                                                      ACESSOS.VENDAS.TELAS
                                                          .DASHBOARD.DS_PATH
                                                  }
                                                  exact
                                                  activeClassName="active"
                                                  className="menu-link"
                                              >
                                                  <span className="menu-text">
                                                      Dashboard
                                                  </span>
                                              </NavLink>
                                          </li>
                                      );
                                  } else return <div key={tela.ID_TELA}></div>;
                              })
                            : null}

                        {UserInfor.TELAS
                            ? UserInfor.TELAS.map((tela) => {
                                  if (
                                      tela.ID_TELA ===
                                      ACESSOS.VENDAS.TELAS.GESTAO_CLIENTES
                                          .ID_TELA
                                  ) {
                                      return (
                                          <li
                                              key={tela.ID_TELA}
                                              className="menu-item"
                                          >
                                              <NavLink
                                                  to={
                                                      ACESSOS.VENDAS.TELAS
                                                          .GESTAO_CLIENTES
                                                          .DS_PATH
                                                  }
                                                  exact
                                                  activeClassName="active"
                                                  className="menu-link"
                                              >
                                                  <span className="menu-text">
                                                      Gestão de Clientes
                                                  </span>
                                              </NavLink>
                                          </li>
                                      );
                                  } else return <div key={tela.ID_TELA}></div>;
                              })
                            : null}

                        {UserInfor.TELAS
                            ? UserInfor.TELAS.map((tela) => {
                                  if (
                                      tela.ID_TELA ===
                                      ACESSOS.VENDAS.TELAS.GESTAO_OPORTUNIDADES
                                          .ID_TELA
                                  ) {
                                      return (
                                          <li
                                              key={tela.ID_TELA}
                                              className="menu-item"
                                          >
                                              <NavLink
                                                  to={
                                                      ACESSOS.VENDAS.TELAS
                                                          .GESTAO_OPORTUNIDADES
                                                          .DS_PATH
                                                  }
                                                  exact
                                                  activeClassName="active"
                                                  className="menu-link"
                                              >
                                                  <span className="menu-text">
                                                      Gestão de Oportunidades
                                                  </span>
                                              </NavLink>
                                          </li>
                                      );
                                  } else return <div key={tela.ID_TELA}></div>;
                              })
                            : null}

                        {mostrarNavDeTela(
                            ACESSOS.VENDAS.TELAS.GESTAO_ATIVIDADES.ID_TELA,
                            UserInfor.TELAS
                        ) && (
                            <li className="menu-item">
                                <NavLink
                                    to={
                                        ACESSOS.VENDAS.TELAS.GESTAO_ATIVIDADES
                                            .DS_PATH
                                    }
                                    exact
                                    activeClassName="active"
                                    className="menu-link"
                                >
                                    <span className="menu-text">
                                        Gestão de Atividades
                                    </span>
                                </NavLink>
                            </li>
                        )}

                        {/* <SubNavDropDown
                            title={"Atendimentos"}
                            telas={[
                                ACESSOS.VENDAS.TELAS.GESTAO_ATENDIMENTOS.TODOS
                                    .ID_TELA,
                            ]}
                        >
                            <SubNavGestaoVendaAtendimentos />
                        </SubNavDropDown> */}

                        <SubNavDropDown
                            title={"Cadastros"}
                            telas={[
                                ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO
                                    .CRIAR_EQUIPE_VENDA.ID_TELA,
                                ACESSOS.VENDAS.TELAS.GESTAO_CADASTRO
                                    .ETAPAS_GRUPO.ID_TELA,
                            ]}
                        >
                            <SubNavGestaoVenCadastro />
                        </SubNavDropDown>

                        <SubNavDropDown
                            title={"Gestão Comercial"}
                            telas={[
                                ACESSOS.VENDAS.TELAS.GESTAO_RESERVAS.ID_TELA,
                                ACESSOS.VENDAS.TELAS.GESTAO_VISITAS.ID_TELA,
                                ACESSOS.VENDAS.TELAS.ANALISE_CREDITO.ID_TELA,
                                ACESSOS.VENDAS.TELAS.GESTAO_PRODUTOS.ID_TELA,
                            ]}
                        >
                            <SubNavProdutos />
                        </SubNavDropDown>

                        <SubNavDropDown
                            title={"Disponibilidade"}
                            telas={[
                                ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO
                                    .ID_TELA,
                            ]}
                        >
                            {mostrarNavDeTela(
                                ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS.ID_TELA,
                                UserInfor.TELAS
                            ) && (
                                <li className="menu-item">
                                    <NavLink
                                        to={
                                            ACESSOS.VENDAS.TELAS.ESPELHO_VENDAS
                                                .DS_PATH
                                        }
                                        exact
                                        activeClassName="active"
                                        className="menu-link"
                                    >
                                        <span className="svg-icon menu-icon">
                                            <FontAwesomeIcon
                                                icon={faMapMarked}
                                            />
                                        </span>
                                        <span className="menu-text">
                                            Espelho Vendas
                                        </span>
                                    </NavLink>
                                </li>
                            )}

                            {mostrarNavDeTela(
                                ACESSOS.VENDAS.PRODUTOS.TELAS.PAINEL_IMPLANTACAO
                                    .ID_TELA,
                                UserInfor.TELAS
                            ) && (
                                <li className="menu-item">
                                    <NavLink
                                        to={
                                            ACESSOS.VENDAS.PRODUTOS.TELAS
                                                .PAINEL_IMPLANTACAO.DS_PATH
                                        }
                                        exact
                                        activeClassName="active"
                                        className="menu-link"
                                    >
                                        <span className="svg-icon menu-icon">
                                            <FontAwesomeIcon
                                                icon={faMapMarked}
                                            />
                                        </span>
                                        <span className="menu-text">
                                            Painel Implantação
                                        </span>
                                    </NavLink>
                                </li>
                            )}
                        </SubNavDropDown>

                        <SubNavDropDown
                            title={"Gestão de Pesquisas"}
                            telas={[
                                // ACESSOS.VENDAS.TELAS.GESTAO_RESPOSTAS.ID_TELA,
                                ACESSOS.VENDAS.TELAS.PESQUISA_SATISFACAO
                                    .ID_TELA,
                            ]}
                        >
                            <SubNavGestaoRespostasVendas />
                        </SubNavDropDown>

                        <SubNavDropDown
                            title={"Relatórios"}
                            telas={[
                                ACESSOS.VENDAS.TELAS
                                    .RELATORIOS_BI_ANALISE_CREDITO.ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_ESTOQUE
                                    .ID_TELA,
                                ACESSOS.VENDAS.TELAS
                                    .RELATORIOS_BI_GESTAO_ATENDIMENTO.ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_LEADS
                                    .ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_MARKETING
                                    .ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_PERDAS
                                    .ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VENDAS
                                    .ID_TELA,
                                ACESSOS.VENDAS.TELAS.RELATORIOS_BI_VISITA
                                    .ID_TELA,
                            ]}
                        >
                            <SubNavRelatoriosBI />
                        </SubNavDropDown>
                    </ul>
                </div>
            </div>
            <div className="d-flex justify-content-end align-items-center">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        history.push(
                            ACESSOS.VENDAS.TELAS.GESTAO_LEADS.CADASTRO_LEAD
                                .DS_PATH
                        );
                    }}
                >
                    <FontAwesomeIcon icon={faUserPlus} /> Novo Lead
                </button>
            </div>
        </>
    );
}
